import React from 'react';
import { camelToSnake } from '../../../../caseUtils';
import { trackCommentary } from '../../../../commentary/commentary.api';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { CommentaryModalContent } from '../../../../commentary/modal/CommentaryModalContent';
import { Commentary, TypeLabel } from '../../../../commentary/commentary.types';
import { Connect, PropsFromRedux } from './SearchCommentariesModalContainer';

type Props = {
  docId: string;
  isOpen: boolean;
  searchType: string;
  onRequestClose: () => void;
  allCommentariesGetter: (
    docId: string,
    query: string,
  ) => Promise<{ data: Array<Commentary> }>;
} & PropsFromRedux;

type State = {
  commentaries: Array<Commentary>;
};

export class RawSearchCommentariesModal extends React.Component<Props, State> {
  state: State = { commentaries: [] };

  async componentDidMount() {
    const { docId, query, allCommentariesGetter } = this.props;
    const commentaries = (await allCommentariesGetter(docId, query)).data;
    this.setState({ commentaries });
  }

  commentaryClicked = (commentary: Commentary, index: number) => {
    const { searchType } = this.props;
    if (commentary.typeLabel !== TypeLabel.PAPER) {
      doctrineAnalytics('Search ModalCommentClicked', {
        ...camelToSnake(commentary),
        reportOriginalQueryKey: true,
        search_type: searchType,
      });
      trackCommentary(commentary.url, 'excerpt_results_commentaries_modal', {
        position: index,
        reportOriginalQueryKey: true,
      });
    }
  };

  render() {
    const { onRequestClose, isOpen } = this.props;
    const { commentaries } = this.state;
    return (
      <CommentaryModalContent
        isOpen={isOpen}
        commentaries={commentaries}
        closeModal={onRequestClose}
        commentaryClicked={this.commentaryClicked}
        source="decision-results"
      />
    );
  }
}

export const SearchCommentariesModal = Connect(RawSearchCommentariesModal);
